  // ========================================
  // IMAGE GALLERY SLIDER FUNCTIONALITY
  // ========================================

  // Store current slide index for each gallery
  window.galleryCurrentSlide = {};

  // Handle checkbox change to show/hide gallery
  window.handleCheckboxGalleryChange = function(checkbox) {
    const galleryId = checkbox.getAttribute('data-gallery-id');

    // Find the gallery within the active step's image container
    const activeStepImage = document.querySelector('.custom-product-steps__image.active-step');
    if (!activeStepImage) {
      return;
    }

    const productImages = activeStepImage.querySelectorAll('.option-image');

    if (!galleryId) {
      // No gallery connected - this checkbox doesn't have a gallery
      // Always check if we need to restore or keep product images hidden

      const stepNumber = parseInt(checkbox.getAttribute('data-step'));
      const targetStep = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);

      // Check if any other checkbox with a gallery is checked in this step
      const allCheckboxesWithGallery = targetStep ? targetStep.querySelectorAll('.custom-product-steps__checkbox-input[data-gallery-id]:checked, .custom-product-steps__nested-checkbox-input[data-gallery-id]:checked') : [];
      let anyGalleryActive = false;

      allCheckboxesWithGallery.forEach(cb => {
        if (cb.getAttribute('data-gallery-id')) {
          anyGalleryActive = true;
        }
      });

      if (!anyGalleryActive) {
        // No gallery is active, restore product images on desktop
        productImages.forEach(img => {
          img.style.opacity = '1';
          img.style.pointerEvents = 'auto';
        });

        // Hide all desktop galleries
        if (activeStepImage) {
          const allGalleries = activeStepImage.querySelectorAll('.custom-product-steps__gallery');
          allGalleries.forEach(g => g.style.display = 'none');
        }

        // Remove all mobile galleries and restore mobile duplicate if on mobile
        if (window.innerWidth <= 768 && targetStep) {
          const allMobileGalleries = targetStep.querySelectorAll('.custom-product-steps__gallery-mobile');
          allMobileGalleries.forEach(g => g.remove());

          // Restore mobile duplicate of the radio option image
          const mobileImagePosition = targetStep.getAttribute('data-mobile-image-position') || 'after_product_info';

          // Skip if set to hide
          if (mobileImagePosition !== 'hide') {
            // Remove existing mobile duplicates first
            const existingDuplicates = targetStep.querySelectorAll('.custom-product-steps__image-mobile-duplicate');
            existingDuplicates.forEach(dup => dup.remove());

            // Get the active image from desktop container
            const activeImage = activeStepImage ? activeStepImage.querySelector('.option-image.active') : null;

            if (activeImage) {
              // Create mobile duplicate
              const imageDuplicate = document.createElement('div');
              imageDuplicate.classList.add('custom-product-steps__image-mobile-duplicate');
              const activeImageClone = activeImage.cloneNode(true);
              imageDuplicate.appendChild(activeImageClone);

              // Insert based on setting
              if (mobileImagePosition === 'inside_selected_option') {
                const selectedRadio = targetStep.querySelector('input[type="radio"]:checked');
                if (selectedRadio) {
                  const selectedOption = selectedRadio.closest('.custom-product-steps__option');
                  if (selectedOption) {
                    selectedOption.appendChild(imageDuplicate);
                  }
                }
              } else {
                // Default: Insert after product-info
                const productInfo = targetStep.querySelector('.custom-product-steps__product-info');
                if (productInfo) {
                  productInfo.after(imageDuplicate);
                }
              }
            }
          }
        }
      }
      return;
    }

    const gallery = activeStepImage.querySelector(`.custom-product-steps__gallery[data-gallery-id="${galleryId}"]`);

    if (!gallery) {
      return;
    }

    if (checkbox.checked) {
      // First, hide all galleries in the active step
      const allGalleries = activeStepImage.querySelectorAll('.custom-product-steps__gallery');
      allGalleries.forEach(g => g.style.display = 'none');

      // Checkbox is checked - show gallery, hide only the product images (not the container)
      gallery.style.display = 'flex';

      productImages.forEach(img => {
        img.style.opacity = '0';
        img.style.pointerEvents = 'none';
      });

      // Initialize gallery if not already done
      if (typeof window.galleryCurrentSlide[galleryId] === 'undefined') {
        window.galleryCurrentSlide[galleryId] = 0;
      }
      // Always show the current slide when gallery is activated
      showGallerySlide(galleryId, window.galleryCurrentSlide[galleryId] || 0);
    } else {
      // Checkbox is unchecked - hide this gallery
      gallery.style.display = 'none';

      // Check if any other checkbox with a gallery is still checked
      const allCheckboxesWithGallery = document.querySelectorAll('.custom-product-steps__checkbox-input[data-gallery-id], .custom-product-steps__nested-checkbox-input[data-gallery-id]');
      let otherCheckedGalleryId = null;

      allCheckboxesWithGallery.forEach(cb => {
        if (cb.checked && cb.getAttribute('data-gallery-id') && cb !== checkbox) {
          otherCheckedGalleryId = cb.getAttribute('data-gallery-id');
        }
      });

      if (otherCheckedGalleryId) {
        // Show the other checked checkbox's gallery
        const otherGallery = activeStepImage.querySelector(`.custom-product-steps__gallery[data-gallery-id="${otherCheckedGalleryId}"]`);
        if (otherGallery) {
          otherGallery.style.display = 'flex';
          productImages.forEach(img => {
            img.style.opacity = '0';
            img.style.pointerEvents = 'none';
          });

          // Initialize gallery if not already done
          if (typeof window.galleryCurrentSlide[otherCheckedGalleryId] === 'undefined') {
            window.galleryCurrentSlide[otherCheckedGalleryId] = 0;
          }
          showGallerySlide(otherCheckedGalleryId, window.galleryCurrentSlide[otherCheckedGalleryId] || 0);
        }
      } else {
        // No other gallery is checked, show product images
        productImages.forEach(img => {
          img.style.opacity = '1';
          img.style.pointerEvents = 'auto';
        });
      }
    }

    // Update mobile gallery inside checkbox containers if on mobile
    if (window.innerWidth <= 768) {
      const stepNumber = parseInt(checkbox.getAttribute('data-step'));
      const targetStep = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);

      if (targetStep) {
        // Remove all mobile galleries from all checkboxes in this step
        const allMobileGalleries = targetStep.querySelectorAll('.custom-product-steps__gallery-mobile');
        allMobileGalleries.forEach(g => g.remove());

        // Add gallery to currently checked nested checkboxes with galleries
        const allCheckedNestedCheckboxesWithGallery = targetStep.querySelectorAll('.custom-product-steps__nested-checkbox-input[data-gallery-id]:checked');

        allCheckedNestedCheckboxesWithGallery.forEach(checkedCb => {
          const cbGalleryId = checkedCb.getAttribute('data-gallery-id');
          const cbNestedCheckbox = checkedCb.closest('.custom-product-steps__nested-checkbox');

          if (cbNestedCheckbox && cbGalleryId && activeStepImage) {
            // Find the gallery in the main container
            const sourceGallery = activeStepImage.querySelector(`.custom-product-steps__gallery[data-gallery-id="${cbGalleryId}"]`);

            if (sourceGallery) {
              // Clone the gallery for mobile
              const galleryClone = sourceGallery.cloneNode(true);
              galleryClone.classList.add('custom-product-steps__gallery-mobile');
              galleryClone.style.position = 'relative';
              galleryClone.style.display = 'flex';

              // Prevent clicks inside gallery from bubbling to checkbox
              galleryClone.addEventListener('click', (e) => {
                e.stopPropagation();
              });

              // Insert after the nested checkbox image
              const nestedCheckboxImage = cbNestedCheckbox.querySelector('.custom-product-steps__nested-checkbox-image');

              if (nestedCheckboxImage) {
                nestedCheckboxImage.after(galleryClone);

                // Re-bind gallery navigation for the cloned gallery
                const prevBtn = galleryClone.querySelector('.custom-product-steps__gallery-arrow--prev');
                const nextBtn = galleryClone.querySelector('.custom-product-steps__gallery-arrow--next');
                const thumbnails = galleryClone.querySelectorAll('.custom-product-steps__gallery-thumbnail');

                if (prevBtn) {
                  prevBtn.onclick = (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    window.galleryPrev(cbGalleryId);
                  };
                }
                if (nextBtn) {
                  nextBtn.onclick = (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    window.galleryNext(cbGalleryId);
                  };
                }
                thumbnails.forEach((thumb, index) => {
                  thumb.onclick = (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    window.galleryGoTo(cbGalleryId, index);
                  };
                });

                // Initialize the gallery
                showGallerySlide(cbGalleryId, window.galleryCurrentSlide[cbGalleryId] || 0);
              }
            }
          }
        });

        // Add gallery to currently checked standalone checkboxes with galleries
        const allCheckedStandaloneCheckboxesWithGallery = targetStep.querySelectorAll('.custom-product-steps__checkbox-input[data-gallery-id]:checked');

        allCheckedStandaloneCheckboxesWithGallery.forEach(checkedCb => {
          const cbGalleryId = checkedCb.getAttribute('data-gallery-id');
          const cbCheckboxOption = checkedCb.closest('.custom-product-steps__checkbox-option');

          if (cbCheckboxOption && cbGalleryId && activeStepImage) {
            // Find the gallery in the main container
            const sourceGallery = activeStepImage.querySelector(`.custom-product-steps__gallery[data-gallery-id="${cbGalleryId}"]`);

            if (sourceGallery) {
              // Clone the gallery for mobile
              const galleryClone = sourceGallery.cloneNode(true);
              galleryClone.classList.add('custom-product-steps__gallery-mobile');
              galleryClone.style.position = 'relative';
              galleryClone.style.display = 'flex';

              // Prevent clicks inside gallery from bubbling to checkbox
              galleryClone.addEventListener('click', (e) => {
                e.stopPropagation();
              });

              // Insert after the checkbox description (or header if no description)
              const checkboxDescription = cbCheckboxOption.querySelector('.custom-product-steps__checkbox-description');
              const checkboxHeader = cbCheckboxOption.querySelector('.custom-product-steps__checkbox-header');

              if (checkboxDescription) {
                checkboxDescription.after(galleryClone);
              } else if (checkboxHeader) {
                checkboxHeader.after(galleryClone);
              }

              // Re-bind gallery navigation for the cloned gallery
              const prevBtn = galleryClone.querySelector('.custom-product-steps__gallery-arrow--prev');
              const nextBtn = galleryClone.querySelector('.custom-product-steps__gallery-arrow--next');
              const thumbnails = galleryClone.querySelectorAll('.custom-product-steps__gallery-thumbnail');

              if (prevBtn) {
                prevBtn.onclick = (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  window.galleryPrev(cbGalleryId);
                };
              }
              if (nextBtn) {
                nextBtn.onclick = (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  window.galleryNext(cbGalleryId);
                };
              }
              thumbnails.forEach((thumb, index) => {
                thumb.onclick = (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  window.galleryGoTo(cbGalleryId, index);
                };
              });

              // Initialize the gallery
              showGallerySlide(cbGalleryId, window.galleryCurrentSlide[cbGalleryId] || 0);
            }
          }
        });
      }
    }
  };

  // Show specific slide in gallery
  function showGallerySlide(galleryId, slideIndex) {
    // Find all galleries with this ID (desktop and mobile)
    const allGalleries = document.querySelectorAll(`[data-gallery-id="${galleryId}"]`);

    if (allGalleries.length === 0) {
      return;
    }

    // Get images from first gallery to check length
    const firstGallery = allGalleries[0];
    const firstImages = firstGallery.querySelectorAll('.custom-product-steps__gallery-image');

    if (firstImages.length === 0) {
      return;
    }

    // Wrap around if index is out of bounds
    if (slideIndex >= firstImages.length) slideIndex = 0;
    if (slideIndex < 0) slideIndex = firstImages.length - 1;

    // Update current slide index
    window.galleryCurrentSlide[galleryId] = slideIndex;

    // Update all galleries with this ID
    allGalleries.forEach(gallery => {
      const images = gallery.querySelectorAll('.custom-product-steps__gallery-image');
      const thumbnails = gallery.querySelectorAll('.custom-product-steps__gallery-thumbnail');

      // Update images
      images.forEach((img, index) => {
        if (index === slideIndex) {
          img.classList.add('active');
        } else {
          img.classList.remove('active');
        }
      });

      // Update thumbnails
      thumbnails.forEach((thumb, index) => {
        if (index === slideIndex) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      });
    });
  }

  // Navigate to previous slide
  window.galleryPrev = function(galleryId) {
    const currentIndex = window.galleryCurrentSlide[galleryId] || 0;
    showGallerySlide(galleryId, currentIndex - 1);
  };

  // Navigate to next slide
  window.galleryNext = function(galleryId) {
    const currentIndex = window.galleryCurrentSlide[galleryId] || 0;
    showGallerySlide(galleryId, currentIndex + 1);
  };

  // Go to specific slide
  window.galleryGoTo = function(galleryId, slideIndex) {
    showGallerySlide(galleryId, slideIndex);
  };

  // Handle select dropdown changes for galleries (Dropdown 2 & 3)
  window.handleDropdownChange = function(selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const galleryId = selectedOption.getAttribute('data-gallery-id');

    // Find the active step's image container
    const activeStepImage = document.querySelector('.custom-product-steps__image.active-step');
    if (!activeStepImage) return;

    // First, hide all galleries in the active step
    const allGalleries = activeStepImage.querySelectorAll('.custom-product-steps__gallery');
    const productImages = activeStepImage.querySelectorAll('.option-image');

    allGalleries.forEach(g => g.style.display = 'none');

    // Check if any checkbox gallery is active
    const anyCheckboxGalleryActive = Array.from(document.querySelectorAll('.custom-product-steps__checkbox-input[data-gallery-id]:checked, .custom-product-steps__nested-checkbox-input[data-gallery-id]:checked')).length > 0;

    if (galleryId && !anyCheckboxGalleryActive) {
      // Show the selected option's gallery
      const gallery = activeStepImage.querySelector(`.custom-product-steps__gallery[data-gallery-id="${galleryId}"]`);
      if (gallery) {
        gallery.style.display = 'flex';
        productImages.forEach(img => {
          img.style.opacity = '0';
          img.style.pointerEvents = 'none';
        });

        // Initialize gallery if not already done
        if (typeof window.galleryCurrentSlide[galleryId] === 'undefined') {
          window.galleryCurrentSlide[galleryId] = 0;
          showGallerySlide(galleryId, 0);
        }
      }
    } else if (!anyCheckboxGalleryActive) {
      // No gallery selected, restore product images
      productImages.forEach(img => {
        img.style.opacity = '1';
        img.style.pointerEvents = 'auto';
      });
    }

    // Update price if needed (original dropdown functionality)
    const stepNumber = parseInt(selectElement.getAttribute('data-step'));
    if (stepNumber && window.updatePrice) {
      window.updatePrice(stepNumber);
    }
  };

  // Initialize galleries on page load
  document.addEventListener('DOMContentLoaded', function() {
    // Set up all galleries with their first slide active
    document.querySelectorAll('.custom-product-steps__gallery').forEach(function(gallery) {
      const galleryId = gallery.getAttribute('data-gallery-id');
      if (galleryId) {
        window.galleryCurrentSlide[galleryId] = 0;
      }
    });
  });

  // ========================================
  // ORIGINAL CODE CONTINUES BELOW
  // ========================================

  // Toggle expandable content
  window.toggleExpandable = function (button, event) {
    event.stopPropagation();
    event.preventDefault();

    const optionCard = button.closest('.custom-product-steps__option');
    const expandableContent = optionCard.querySelector('.custom-product-steps__expandable-content');

    button.classList.toggle('expanded');
    expandableContent.classList.toggle('expanded');

    // Always manage inline styles to ensure dropdowns work even when option is not selected
    if (expandableContent.classList.contains('expanded')) {
      // Opening - apply inline styles
      expandableContent.style.gridTemplateRows = '1fr';
      expandableContent.style.marginTop = '1.4vw';
      expandableContent.style.opacity = '1';

      // AUTO-SELECT DISABLED: Let customer manually select nested checkboxes
      // const nestedCheckboxes = optionCard.querySelectorAll('.custom-product-steps__nested-checkbox-input');
      // const enabledCheckboxes = Array.from(nestedCheckboxes).filter(cb => !cb.disabled);
      // const anyChecked = enabledCheckboxes.some(cb => cb.checked);
      // if (enabledCheckboxes.length > 0 && !anyChecked) {
      //   const firstCheckbox = enabledCheckboxes[0];
      //   firstCheckbox.checked = true;
      //   if (window.updateNestedCheckboxState) {
      //     window.updateNestedCheckboxState(firstCheckbox);
      //   }
      //   if (window.handleCheckboxGalleryChange) {
      //     window.handleCheckboxGalleryChange(firstCheckbox);
      //   }
      // }
    } else {
      // Closing - remove inline styles
      expandableContent.style.gridTemplateRows = '';
      expandableContent.style.marginTop = '';
      expandableContent.style.opacity = '';
    }
  };

  // Change quantity for nested checkboxes
  window.changeQuantity = function (button, change, event) {
    event.stopPropagation();
    event.preventDefault();

    const quantityInput = button.parentElement.querySelector('.custom-product-steps__quantity-input');
    let currentValue = parseInt(quantityInput.value) || 1;
    let newValue = currentValue + change;

    // Enforce min/max
    const min = parseInt(quantityInput.getAttribute('min')) || 1;
    const max = parseInt(quantityInput.getAttribute('max')) || 99;

    if (newValue >= min && newValue <= max) {
      quantityInput.value = newValue;

      // Update price when quantity changes
      const nestedId = quantityInput.getAttribute('data-nested-id');
      const checkbox = nestedId ? document.getElementById(nestedId) : null;
      const stepNumber = checkbox ? parseInt(checkbox.getAttribute('data-step')) : null;
      if (stepNumber && window.updatePrice) {
        window.updatePrice(stepNumber);
      }
    }
  };

  // Update nested checkbox state (selected/unselected visual)
  window.updateNestedCheckboxState = function (checkbox) {
    const nestedCard = checkbox.closest('.custom-product-steps__nested-checkbox');
    const stepNumber = parseInt(checkbox.getAttribute('data-step'));
    const parentOption = checkbox.getAttribute('data-parent-option'); // Which radio option this belongs to

    // Check if single selection mode is enabled for this step
    const stepContent = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);
    const singleSelectionMode = stepContent?.getAttribute('data-single-selection-mode') === 'true';

    console.log('🚀 Nested checkbox changed:', {
      checked: checkbox.checked,
      parentOption: parentOption,
      singleSelectionMode: singleSelectionMode
    });

    // If single selection mode is enabled and this checkbox is being checked
    if (singleSelectionMode && checkbox.checked) {
      console.log('🎯 Single selection mode - unchecking products from OTHER radio options...');

      // Find all nested checkboxes in this step
      const allNestedCheckboxes = stepContent.querySelectorAll('.custom-product-steps__nested-checkbox-input');

      let uncheckedCount = 0;
      allNestedCheckboxes.forEach((cb) => {
        const otherParentOption = cb.getAttribute('data-parent-option');

        // Only uncheck if it's from a DIFFERENT radio option and is checked
        if (otherParentOption !== parentOption && cb.checked) {
          console.log('❌ Unchecking from other radio option:', cb.id);
          uncheckedCount++;

          cb.checked = false;

          // Remove selected state from the card
          const otherCard = cb.closest('.custom-product-steps__nested-checkbox');
          if (otherCard) {
            otherCard.classList.remove('selected');
          }

          // Handle gallery
          if (window.handleCheckboxGalleryChange) {
            window.handleCheckboxGalleryChange(cb);
          }
        }
      });

      console.log('✅ Unchecked', uncheckedCount, 'products from other radio options');
    }

    // Toggle selected state
    if (checkbox.checked) {
      nestedCard.classList.add('selected');
    } else {
      nestedCard.classList.remove('selected');
    }

    // Update price when nested checkbox changes
    if (stepNumber && window.updatePrice) {
      window.updatePrice(stepNumber);
    }
  };

  // Handle nested checkbox click based on click mode setting
  window.handleNestedCheckboxCardClick = function (event) {
    const section = document.querySelector('.custom-product-steps');
    const clickMode = section?.getAttribute('data-nested-checkbox-click-mode') || 'current';

    // If mode is 'current', do nothing (default label/checkbox behavior handles it)
    if (clickMode === 'current') {
      return;
    }

    // If mode is 'checkbox_only', prevent card clicks from toggling
    if (clickMode === 'checkbox_only') {
      // Only allow clicks directly on the checkbox input
      if (event.target.classList.contains('custom-product-steps__nested-checkbox-input')) {
        return; // Let the default checkbox behavior handle it
      }
      // For everything else, prevent toggle
      return;
    }

    // If mode is 'click_anywhere', toggle checkbox on card click (except quantity controls)
    if (clickMode === 'click_anywhere') {
      const target = event.target;

      // Don't toggle if clicking on quantity controls
      if (target.closest('.custom-product-steps__quantity-selector') ||
          target.closest('.custom-product-steps__quantity-btn') ||
          target.classList.contains('custom-product-steps__quantity-input')) {
        return;
      }

      // Don't double-toggle if clicking directly on checkbox (it handles itself)
      if (target.classList.contains('custom-product-steps__nested-checkbox-input')) {
        return;
      }

      // Don't double-toggle if clicking on label (it's associated with checkbox via 'for')
      if (target.classList.contains('custom-product-steps__nested-checkbox-label') ||
          target.closest('.custom-product-steps__nested-checkbox-label')) {
        return;
      }

      // Find the checkbox and toggle it
      const card = event.currentTarget;
      const checkbox = card.querySelector('.custom-product-steps__nested-checkbox-input');
      if (checkbox && !checkbox.disabled) {
        checkbox.checked = !checkbox.checked;
        window.updateNestedCheckboxState(checkbox);
        window.handleCheckboxGalleryChange(checkbox);
      }
    }
  };

  // Initialize nested checkbox click handlers based on mode
  window.initNestedCheckboxClickMode = function() {
    const section = document.querySelector('.custom-product-steps');
    const clickMode = section?.getAttribute('data-nested-checkbox-click-mode') || 'current';

    if (clickMode === 'click_anywhere') {
      // Add click handlers to all nested checkbox cards
      document.querySelectorAll('.custom-product-steps__nested-checkbox').forEach(function(card) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', window.handleNestedCheckboxCardClick);
      });
    } else if (clickMode === 'checkbox_only') {
      // Remove the 'for' attribute from labels to prevent label clicks from toggling
      document.querySelectorAll('.custom-product-steps__nested-checkbox-label').forEach(function(label) {
        label.removeAttribute('for');
        label.style.cursor = 'default';
      });
    }
  };

  // Toggle dropdown accordion
  window.toggleDropdownAccordion = function (header) {
    const accordion = header.closest('.custom-product-steps__dropdown-accordion');
    const content = accordion.querySelector('.custom-product-steps__dropdown-content');
    const arrow = accordion.querySelector('.custom-product-steps__dropdown-arrow');

    content.classList.toggle('expanded');
    arrow.classList.toggle('expanded');
  };

  // Handle dropdown product checkbox changes
  window.handleDropdownProductChange = function (checkbox) {
    const product = checkbox.closest('.custom-product-steps__dropdown-product');
    const stepNumber = parseInt(checkbox.getAttribute('data-step'));
    const dropdownId = checkbox.getAttribute('data-dropdown-id');

    // Toggle selected state
    if (checkbox.checked) {
      product.classList.add('selected');
    } else {
      product.classList.remove('selected');
    }

    // Update dropdown total price
    updateDropdownTotal(dropdownId, stepNumber);

    // Update main step price
    if (stepNumber && window.updatePrice) {
      window.updatePrice(stepNumber);
    }
  };

  // Update dropdown total price
  function updateDropdownTotal(dropdownId, stepNumber) {
    let total = 0;
    const checkboxes = document.querySelectorAll(`[data-dropdown-id="${dropdownId}"]:checked`);

    checkboxes.forEach((checkbox) => {
      const priceModifier = parseFloat(checkbox.getAttribute('data-price-modifier')) || 0;
      const checkboxId = checkbox.id;
      const quantityInput = document.querySelector(`[data-dropdown-product-id="${checkboxId}"]`);
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      total += priceModifier * quantity;
    });

    const totalElement = document.getElementById(dropdownId + '-total');
    if (totalElement) {
      totalElement.textContent = total > 0 ? `+$${total.toFixed(0)}` : '$0';
    }
  }

  (function () {
    let currentStepNumber = 1;
    const stepData = {};

    // Check if batch mode is enabled
    const section = document.querySelector('.custom-product-steps');
    const batchMode = section?.getAttribute('data-batch-mode') === 'true';

    // Function to parse price string to number
    function parsePrice(priceStr) {
      if (!priceStr || priceStr === '' || priceStr.toLowerCase() === 'free') return 0;
      // Remove currency symbols and parse
      const cleaned = priceStr.replace(/[^0-9.\-+]/g, '');
      return parseFloat(cleaned) || 0;
    }

    // Function to format price
    function formatPrice(price) {
      return '$' + Math.abs(price).toFixed(0);
    }

    // Function to calculate total price based on all previous selections
    function calculateTotalPrice(currentStep) {
      const allSteps = document.querySelectorAll('.custom-product-steps__step-content');
      const stepNumbers = Array.from(allSteps)
        .map((step) => parseInt(step.getAttribute('data-step')))
        .sort((a, b) => a - b);

      // Check if price accumulation is enabled (global setting)
      const currentStepElement = document.querySelector(
        `.custom-product-steps__step-content[data-step="${currentStep}"]`
      );
      const accumulatePriceAttr = currentStepElement?.getAttribute('data-accumulate-price');
      const accumulatePrice = accumulatePriceAttr === 'true';

      let totalPrice = 0;

      if (accumulatePrice) {
        // ACCUMULATE MODE: Add base prices and price modifiers from all steps up to and including current step
        stepNumbers.forEach((stepNum) => {
          if (stepNum <= currentStep) {
            const stepElement = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNum}"]`);
            const priceElement = stepElement?.querySelector('.custom-product-steps__price');
            const stepBasePrice = priceElement ? parsePrice(priceElement.getAttribute('data-base-price')) : 0;

            // Add base price from this step
            totalPrice += stepBasePrice;

            // Add price modifier from selected option
            let selectedRadio;
            if (stepNum === currentStep) {
              selectedRadio = stepElement?.querySelector('input[type="radio"]:checked');
            } else if (stepData[stepNum] && stepData[stepNum].id) {
              selectedRadio = document.getElementById(stepData[stepNum].id);
            } else {
              selectedRadio = stepElement?.querySelector('input[type="radio"]:checked');
            }

            if (selectedRadio) {
              const priceModifier = selectedRadio.getAttribute('data-price-modifier');
              totalPrice += parsePrice(priceModifier);
            }

            // Add checkbox prices for this step
            const stepCheckboxes = stepElement?.querySelectorAll('.custom-product-steps__checkbox-input:checked');
            if (stepCheckboxes) {
              stepCheckboxes.forEach((checkbox) => {
                const checkboxModifier = checkbox.getAttribute('data-price-modifier');
                totalPrice += parsePrice(checkboxModifier);
              });
            }

            // Add nested checkbox prices for this step
            const nestedCheckboxes = stepElement?.querySelectorAll(
              '.custom-product-steps__nested-checkbox-input:checked'
            );
            if (nestedCheckboxes) {
              nestedCheckboxes.forEach((checkbox) => {
                // Skip checkboxes that are disabled because their parent option is not selected
                if (checkbox.getAttribute('data-parent-disabled') === 'true') {
                  return; // Skip this checkbox in price calculation
                }

                const nestedModifier = checkbox.getAttribute('data-price-modifier');
                const nestedId = checkbox.id;
                const quantityInput = stepElement?.querySelector(
                  `.custom-product-steps__quantity-input[data-nested-id="${nestedId}"]`
                );
                const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
                totalPrice += parsePrice(nestedModifier) * quantity;
              });
            }

            // Add dropdown product prices for this step
            const stepDropdownProducts = stepElement?.querySelectorAll(
              '.custom-product-steps__dropdown-product-checkbox:checked'
            );
            if (stepDropdownProducts) {
              stepDropdownProducts.forEach((checkbox) => {
                const dropdownModifier = checkbox.getAttribute('data-price-modifier');
                const checkboxId = checkbox.id;
                const quantityInput = stepElement?.querySelector(`[data-dropdown-product-id="${checkboxId}"]`);
                const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
                totalPrice += parsePrice(dropdownModifier) * quantity;
              });
            }
          }
        });
      } else {
        // SIMPLE MODE: Only add current step's base price and selected option modifier
        const priceElement = currentStepElement?.querySelector('.custom-product-steps__price');
        const basePrice = priceElement ? parsePrice(priceElement.getAttribute('data-base-price')) : 0;
        totalPrice = basePrice;

        const selectedRadio = currentStepElement?.querySelector('input[type="radio"]:checked');
        if (selectedRadio) {
          const priceModifier = selectedRadio.getAttribute('data-price-modifier');
          totalPrice += parsePrice(priceModifier);
        }

        // Add checkbox prices for current step
        const currentCheckboxes = currentStepElement?.querySelectorAll('.custom-product-steps__checkbox-input:checked');
        if (currentCheckboxes) {
          currentCheckboxes.forEach((checkbox) => {
            const checkboxModifier = checkbox.getAttribute('data-price-modifier');
            totalPrice += parsePrice(checkboxModifier);
          });
        }

        // Add nested checkbox prices for current step
        const currentNestedCheckboxes = currentStepElement?.querySelectorAll(
          '.custom-product-steps__nested-checkbox-input:checked'
        );
        if (currentNestedCheckboxes) {
          currentNestedCheckboxes.forEach((checkbox) => {
            // Skip checkboxes that are disabled because their parent option is not selected
            if (checkbox.getAttribute('data-parent-disabled') === 'true') {
              return; // Skip this checkbox in price calculation
            }

            const nestedModifier = checkbox.getAttribute('data-price-modifier');
            const nestedId = checkbox.id;
            const quantityInput = currentStepElement?.querySelector(
              `.custom-product-steps__quantity-input[data-nested-id="${nestedId}"]`
            );
            const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
            totalPrice += parsePrice(nestedModifier) * quantity;
          });
        }

        // Add dropdown product prices for current step
        const currentDropdownProducts = currentStepElement?.querySelectorAll(
          '.custom-product-steps__dropdown-product-checkbox:checked'
        );
        if (currentDropdownProducts) {
          currentDropdownProducts.forEach((checkbox) => {
            const dropdownModifier = checkbox.getAttribute('data-price-modifier');
            const checkboxId = checkbox.id;
            const quantityInput = currentStepElement?.querySelector(`[data-dropdown-product-id="${checkboxId}"]`);
            const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
            totalPrice += parsePrice(dropdownModifier) * quantity;
          });
        }
      }

      return totalPrice;
    }

    // Function to update displayed price
    function updatePrice(stepNumber) {
      const totalPrice = calculateTotalPrice(stepNumber);
      const priceElement = document.querySelector(`.custom-product-steps__price[data-step="${stepNumber}"]`);

      if (priceElement) {
        priceElement.textContent = formatPrice(totalPrice);
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      const options = document.querySelectorAll('.custom-product-steps__option');
      const radioInputs = document.querySelectorAll('.custom-product-steps__option input[type="radio"]');

      // Initialize nested checkbox click mode handlers
      if (window.initNestedCheckboxClickMode) {
        window.initNestedCheckboxClickMode();
      }

      // Check if there's a step in URL hash
      const urlHash = window.location.hash;
      if (urlHash && urlHash.startsWith('#step-')) {
        const stepFromUrl = parseInt(urlHash.replace('#step-', ''));
        if (!isNaN(stepFromUrl)) {
          currentStepNumber = stepFromUrl;
        }
      }

      // Initialize - show step from URL or first step
      showStep(currentStepNumber);

      // Function to update the displayed image based on selected radio
      function updateImage(radio) {
        if (!radio) return;

        const stepNumber = radio.getAttribute('data-step');
        const radioId = radio.id;
        const imageContainer = document.querySelector(`#step-${stepNumber}-images`);

        if (!imageContainer) return;

        // Hide all option images in this step
        const allOptionImages = imageContainer.querySelectorAll('.option-image');
        allOptionImages.forEach((img) => img.classList.remove('active'));

        // Show the selected option's image
        const selectedImage = imageContainer.querySelector(`.option-image[data-option="${radioId}"]`);
        if (selectedImage) {
          selectedImage.classList.add('active');
          imageContainer.classList.add('has-active-option');
        } else {
          // No specific image for this option, show default
          imageContainer.classList.remove('has-active-option');
        }

        // Handle gallery for radio options (main product gallery)
        const radioGalleryId = radio.getAttribute('data-gallery-id');
        const allGalleries = imageContainer.querySelectorAll('.custom-product-steps__gallery');

        if (radioGalleryId) {
          // Radio has a gallery - hide option images and show gallery
          allOptionImages.forEach(img => {
            img.style.opacity = '0';
            img.style.pointerEvents = 'none';
          });

          // Hide all galleries first
          allGalleries.forEach(g => g.style.display = 'none');

          // Show the matching gallery
          const gallery = imageContainer.querySelector(`.custom-product-steps__gallery[data-gallery-id="${radioGalleryId}"]`);
          if (gallery) {
            gallery.style.display = 'flex';
            if (typeof window.galleryCurrentSlide[radioGalleryId] === 'undefined') {
              window.galleryCurrentSlide[radioGalleryId] = 0;
            }
            showGallerySlide(radioGalleryId, window.galleryCurrentSlide[radioGalleryId] || 0);
          }
        } else {
          // No gallery for this radio - check if any checked checkboxes have galleries
          const targetStepForGallery = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);
          const checkedCheckboxesWithGallery = targetStepForGallery ? targetStepForGallery.querySelectorAll('.custom-product-steps__nested-checkbox-input[data-gallery-id]:checked, .custom-product-steps__checkbox-input[data-gallery-id]:checked') : [];

          let activeCheckboxGalleryId = null;
          checkedCheckboxesWithGallery.forEach(cb => {
            if (cb.getAttribute('data-gallery-id')) {
              activeCheckboxGalleryId = cb.getAttribute('data-gallery-id');
            }
          });

          if (!activeCheckboxGalleryId) {
            // No gallery active - restore option images and hide galleries
            allOptionImages.forEach(img => {
              img.style.opacity = '1';
              img.style.pointerEvents = 'auto';
            });
            allGalleries.forEach(g => g.style.display = 'none');
          }
        }

        // Update mobile duplicate
        if (window.innerWidth <= 768) {
          const targetStep = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);

          if (targetStep) {
            const mobileImagePosition = targetStep.getAttribute('data-mobile-image-position') || 'after_product_info';

            // Remove any existing mobile duplicates
            const existingDuplicates = targetStep.querySelectorAll('.custom-product-steps__image-mobile-duplicate');
            existingDuplicates.forEach(dup => dup.remove());

            // Skip creating image if set to hide
            if (mobileImagePosition === 'hide') {
              return;
            }

            // Check if there's an active gallery first
            const activeGallery = imageContainer.querySelector('.custom-product-steps__gallery[style*="display: flex"], .custom-product-steps__gallery[style*="display:flex"]');

            if (activeGallery) {
              // Create a wrapper div
              const imageDuplicate = document.createElement('div');
              imageDuplicate.classList.add('custom-product-steps__image-mobile-duplicate');

              // Clone the gallery
              const galleryClone = activeGallery.cloneNode(true);
              galleryClone.style.position = 'relative';
              galleryClone.style.display = 'flex';
              imageDuplicate.appendChild(galleryClone);

              // Insert based on setting
              if (mobileImagePosition === 'inside_selected_option') {
                // Insert inside the selected radio option
                const selectedOption = radio.closest('.custom-product-steps__option');
                if (selectedOption) {
                  selectedOption.appendChild(imageDuplicate);
                }
              } else {
                // Default: Insert after product-info
                const productInfo = targetStep.querySelector('.custom-product-steps__product-info');
                if (productInfo) {
                  productInfo.after(imageDuplicate);
                }
              }
            } else {
              // Get only the active image
              const activeImage = imageContainer.querySelector('.option-image.active');
              if (activeImage) {
                // Create a wrapper div
                const imageDuplicate = document.createElement('div');
                imageDuplicate.classList.add('custom-product-steps__image-mobile-duplicate');

                // Clone only the active image
                const activeImageClone = activeImage.cloneNode(true);
                imageDuplicate.appendChild(activeImageClone);

                // Insert based on setting
                if (mobileImagePosition === 'inside_selected_option') {
                  // Insert inside the selected radio option
                  const selectedOption = radio.closest('.custom-product-steps__option');
                  if (selectedOption) {
                    selectedOption.appendChild(imageDuplicate);
                  }
                } else {
                  // Default: Insert after product-info
                  const productInfo = targetStep.querySelector('.custom-product-steps__product-info');
                  if (productInfo) {
                    productInfo.after(imageDuplicate);
                  }
                }
              }
            }
          }
        }
      }

      // Add click handlers to option containers
      options.forEach((option) => {
        option.addEventListener('click', function (e) {
          // Don't trigger if clicking directly on the radio input
          if (e.target.tagName !== 'INPUT') {
            const radio = this.querySelector('input[type="radio"]');
            radio.checked = true;
            updateSelectedState();
            updateImage(radio);
            handleNestedCheckboxBehavior(radio);

            // Handle single selection mode: uncheck nested checkboxes from other radio options
            const stepNumber = parseInt(radio.getAttribute('data-step'));
            const stepContent = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);
            const singleSelectionMode = stepContent?.getAttribute('data-single-selection-mode') === 'true';

            if (singleSelectionMode) {
              const currentRadioId = radio.id;

              // Find all nested checkboxes in this step
              const allNestedCheckboxes = stepContent.querySelectorAll('.custom-product-steps__nested-checkbox-input');

              allNestedCheckboxes.forEach((cb) => {
                const parentOption = cb.getAttribute('data-parent-option');

                // Uncheck if it belongs to a different radio option and is checked
                if (parentOption !== currentRadioId && cb.checked) {
                  cb.checked = false;

                  // Remove selected state
                  const nestedCard = cb.closest('.custom-product-steps__nested-checkbox');
                  if (nestedCard) {
                    nestedCard.classList.remove('selected');
                  }

                  // Handle gallery
                  if (window.handleCheckboxGalleryChange) {
                    window.handleCheckboxGalleryChange(cb);
                  }
                }
              });
            }

           // Update price when selection changes via click
            if (stepNumber) {
              updatePrice(stepNumber);
              validateContinueButton(stepNumber);
            }

           // On mobile, scroll back to top after switching options
            if (window.innerWidth <= 768) {
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }, 150);
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }, 400);
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }, 650);
            }
          }
        });
      });

      // Add change handlers to radio inputs
      radioInputs.forEach((radio) => {
        radio.addEventListener('change', function () {
          updateSelectedState();
          updateImage(this);
          handleNestedCheckboxBehavior(this);

          // Handle single selection mode: uncheck nested checkboxes from other radio options
          const stepNumber = parseInt(this.getAttribute('data-step'));
          const stepContent = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);
          const singleSelectionMode = stepContent?.getAttribute('data-single-selection-mode') === 'true';

          if (singleSelectionMode) {
            const currentRadioId = this.id;
            console.log('🔘 Radio changed - unchecking nested checkboxes from other options...', {
              currentRadioId: currentRadioId,
              singleSelectionMode: singleSelectionMode
            });

            // Find all nested checkboxes in this step
            const allNestedCheckboxes = stepContent.querySelectorAll('.custom-product-steps__nested-checkbox-input');

            let uncheckedCount = 0;
            allNestedCheckboxes.forEach((cb) => {
              const parentOption = cb.getAttribute('data-parent-option');

              // Uncheck if it belongs to a different radio option and is checked
              if (parentOption !== currentRadioId && cb.checked) {
                console.log('❌ Unchecking nested checkbox from other radio:', cb.id);
                uncheckedCount++;

                cb.checked = false;

                // Remove selected state
                const nestedCard = cb.closest('.custom-product-steps__nested-checkbox');
                if (nestedCard) {
                  nestedCard.classList.remove('selected');
                }

                // Handle gallery
                if (window.handleCheckboxGalleryChange) {
                  window.handleCheckboxGalleryChange(cb);
                }
              }
            });

            console.log('✅ Unchecked', uncheckedCount, 'nested checkboxes from other radio options');
          }

         // Update price when selection changes
          if (stepNumber) {
            updatePrice(stepNumber);
            validateContinueButton(stepNumber);
          }

          // On mobile, scroll back to top of step after switching options
          if (window.innerWidth <= 768) {
            const stepSection = document.querySelector('.custom-product-steps');
            if (stepSection) {
              setTimeout(() => {
                stepSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 100);
            }
          }
        });
      });

      // Add change handlers to checkbox inputs
      const checkboxInputs = document.querySelectorAll('.custom-product-steps__checkbox-input');
      checkboxInputs.forEach((checkbox) => {
        checkbox.addEventListener('change', function () {
          // Update price when checkbox changes
          const stepNumber = parseInt(this.getAttribute('data-step'));
          if (stepNumber) {
            updatePrice(stepNumber);
          }
        });
      });

      // Add change handlers to nested checkbox inputs
      const nestedCheckboxInputs = document.querySelectorAll('.custom-product-steps__nested-checkbox-input');
      nestedCheckboxInputs.forEach((checkbox) => {
        checkbox.addEventListener('change', function () {
          // Update price when nested checkbox changes
          const stepNumber = parseInt(this.getAttribute('data-step'));
          if (stepNumber) {
            updatePrice(stepNumber);
            validateContinueButton(stepNumber);
          }
        });
      });

      function updateSelectedState() {
        options.forEach((option) => {
          const radio = option.querySelector('input[type="radio"]');
          if (radio.checked) {
            option.classList.add('selected');
          } else {
            option.classList.remove('selected');
          }
        });
      }

      // Handle nested checkbox behavior based on setting
      function handleNestedCheckboxBehavior(selectedRadio) {
        const section = document.querySelector('.custom-product-steps');
        const behavior = section?.getAttribute('data-nested-checkbox-behavior') || 'collapse';
        const stepElement = selectedRadio.closest('.custom-product-steps__step-content');
        if (!stepElement) return;

        const selectedParentOption = selectedRadio.getAttribute('id');
        const allOptions = stepElement.querySelectorAll('.custom-product-steps__option');

        allOptions.forEach((option) => {
          const radio = option.querySelector('input[type="radio"]');
          const expandableContent = option.querySelector('.custom-product-steps__expandable-content');
          const nestedCheckboxes = option.querySelectorAll('.custom-product-steps__nested-checkbox-input');
          const toggle = option.querySelector('.custom-product-steps__option-toggle');

         if (behavior === 'collapse') {
            // Check if this step requires product selection
            const requireProductSelection = stepElement?.getAttribute('data-require-product-selection') === 'true';

            // COLLAPSE MODE: Control dropdown open/close state
            if (radio && radio.id !== selectedParentOption) {
              if (requireProductSelection) {
                // REQUIRED STEP: Close dropdown and uncheck nested checkboxes
                if (expandableContent && toggle) {
                  expandableContent.classList.remove('expanded');
                  toggle.classList.remove('expanded');
                  expandableContent.style.gridTemplateRows = '';
                  expandableContent.style.marginTop = '';
                  expandableContent.style.opacity = '';
                }

                // CLEAR: Uncheck any nested checkboxes in collapsed options
                nestedCheckboxes.forEach((cb) => {
                  if (cb.checked) {
                    cb.checked = false;
                    const nestedCard = cb.closest('.custom-product-steps__nested-checkbox');
                    if (nestedCard) {
                      nestedCard.classList.remove('selected');
                    }
                    if (window.handleCheckboxGalleryChange) {
                      window.handleCheckboxGalleryChange(cb);
                    }
                  }
                });
              }
              // OPTIONAL STEP: Do nothing - leave other dropdowns and checkboxes as they are
            } else if (radio && radio.id === selectedParentOption) {
              // This IS the selected option - open the dropdown
              if (expandableContent && toggle) {
                expandableContent.classList.add('expanded');
                toggle.classList.add('expanded');
                // Apply inline styles to force open
                expandableContent.style.gridTemplateRows = '1fr';
                expandableContent.style.marginTop = '1.4vw';
                expandableContent.style.opacity = '1';
              }

             // Auto-select first nested checkbox only if product selection is required for this step
              const requireProductSelection = stepElement?.getAttribute('data-require-product-selection') === 'true';
              if (requireProductSelection) {
                const enabledNestedCheckboxes = Array.from(nestedCheckboxes).filter(cb => !cb.disabled);
                const anyChecked = enabledNestedCheckboxes.some(cb => cb.checked);
                if (enabledNestedCheckboxes.length > 0 && !anyChecked) {
                  const firstCheckbox = enabledNestedCheckboxes[0];
                  firstCheckbox.checked = true;
                  if (window.updateNestedCheckboxState) {
                    window.updateNestedCheckboxState(firstCheckbox);
                  }
                  if (window.handleCheckboxGalleryChange) {
                    window.handleCheckboxGalleryChange(firstCheckbox);
                  }
                }
              }
            }
          } else if (behavior === 'disable') {
            // DISABLE MODE: Only enable/disable checkboxes, keep dropdowns in their current state
            if (radio && radio.id !== selectedParentOption) {
              // This is NOT the selected option - disable checkboxes
              nestedCheckboxes.forEach((checkbox) => {
                checkbox.disabled = true;
                checkbox.setAttribute('data-parent-disabled', 'true');
                const parentCheckbox = checkbox.closest('.custom-product-steps__nested-checkbox');
                if (parentCheckbox) {
                  parentCheckbox.style.opacity = '0.5';
                  parentCheckbox.style.pointerEvents = 'none';
                }
              });

              // Force dropdown to stay open if it has the expanded class
              if (expandableContent && toggle && toggle.classList.contains('expanded')) {
                expandableContent.style.gridTemplateRows = '1fr';
                expandableContent.style.marginTop = '1.4vw';
                expandableContent.style.opacity = '1';
              }
            } else if (radio && radio.id === selectedParentOption) {
              // This IS the selected option - enable checkboxes
              nestedCheckboxes.forEach((checkbox) => {
                checkbox.disabled = false;
                checkbox.removeAttribute('data-parent-disabled');
                const parentCheckbox = checkbox.closest('.custom-product-steps__nested-checkbox');
                if (parentCheckbox) {
                  parentCheckbox.style.opacity = '1';
                  parentCheckbox.style.pointerEvents = 'auto';
                }
              });

              // Force dropdown to stay open if it has the expanded class
              if (expandableContent && toggle && toggle.classList.contains('expanded')) {
                expandableContent.style.gridTemplateRows = '1fr';
                expandableContent.style.marginTop = '1.4vw';
                expandableContent.style.opacity = '1';
              }
            }
          }
        });
      }

      // Initialize selected state and images
      updateSelectedState();

      // Initialize images for all checked radios
      // NOTE: We do NOT call handleNestedCheckboxBehavior here on page load
      // so that "Default Expanded State" setting is respected for all options
      // The behavior (collapse/disable) only applies when user clicks to switch options
      radioInputs.forEach((radio) => {
        if (radio.checked) {
          updateImage(radio);
        }
      });

      // Function to validate continue button state
      function validateContinueButton(stepNumber) {
        const stepElement = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);
        if (!stepElement) return;

        const continueButton = stepElement.querySelector('.custom-product-steps__continue-button');
        if (!continueButton) return;

        // Check if product selection is required for this step
        const requireProductSelection = stepElement.dataset.requireProductSelection === 'true';

        // If product selection is not required, always enable the button
        if (!requireProductSelection) {
          continueButton.disabled = false;
          return;
        }

        const selectedRadio = stepElement.querySelector('input[type="radio"]:checked');
        if (!selectedRadio) {
          continueButton.disabled = false;
          return;
        }

        // Check if selected radio has nested checkboxes
        const selectedOption = selectedRadio.closest('.custom-product-steps__option');
        const nestedCheckboxes = selectedOption?.querySelectorAll('.custom-product-steps__nested-checkbox-input');

        if (nestedCheckboxes && nestedCheckboxes.length > 0) {
          // Check if at least one checkbox is checked and not disabled
          const hasCheckedCheckbox = Array.from(nestedCheckboxes).some((checkbox) => {
            return checkbox.checked && !checkbox.disabled;
          });

          continueButton.disabled = !hasCheckedCheckbox;
        } else {
          // No nested checkboxes, button should be enabled
          continueButton.disabled = false;
        }
      }

      // Make functions globally accessible
      window.updateStepImage = updateImage;
      window.handleNestedCheckboxBehavior = handleNestedCheckboxBehavior;
      window.validateContinueButton = validateContinueButton;
    });

    function showStep(stepNumber) {
      // Hide all steps and images
      const allSteps = document.querySelectorAll('.custom-product-steps__step-content');
      const allImages = document.querySelectorAll('.custom-product-steps__image[data-step-image]');

      allSteps.forEach((step) => step.classList.remove('active-step'));
      allImages.forEach((img) => img.classList.remove('active-step'));

      // Show the requested step
      const targetStep = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);
      const targetImage = document.querySelector(`.custom-product-steps__image[data-step-image="${stepNumber}"]`);

      if (targetStep) {
        targetStep.classList.add('active-step');
        currentStepNumber = stepNumber;

        // Update URL hash
        updateUrl(stepNumber);

        // Restore previously selected option if exists
        if (stepData[stepNumber] && stepData[stepNumber].id) {
          const savedRadio = document.getElementById(stepData[stepNumber].id);
          if (savedRadio) {
            savedRadio.checked = true;

            // Update visual state
            const allOptions = targetStep.querySelectorAll('.custom-product-steps__option');
            allOptions.forEach((option) => {
              const radio = option.querySelector('input[type="radio"]');
              if (radio && radio.checked) {
                option.classList.add('selected');
              } else {
                option.classList.remove('selected');
              }
            });

            // Update image for restored selection
            if (window.updateStepImage) {
              window.updateStepImage(savedRadio);
            }

            // Apply nested checkbox behavior
            if (window.handleNestedCheckboxBehavior) {
              window.handleNestedCheckboxBehavior(savedRadio);
            }
          }

          // Restore checkbox states
          if (stepData[stepNumber].checkboxes) {
            // First uncheck all checkboxes for this step
            const allCheckboxes = targetStep.querySelectorAll('.custom-product-steps__checkbox-input');
            allCheckboxes.forEach((cb) => (cb.checked = false));

            // Then check the saved ones
            stepData[stepNumber].checkboxes.forEach((checkboxInfo) => {
              const checkbox = document.getElementById(checkboxInfo.id);
              if (checkbox) {
                checkbox.checked = true;

                // Show gallery if checkbox has one
                if (window.handleCheckboxGalleryChange) {
                  window.handleCheckboxGalleryChange(checkbox);
                }
              }
            });
          }

          // Restore nested checkbox states
          if (stepData[stepNumber].nestedCheckboxes) {
            // First uncheck all nested checkboxes for this step
            const allNestedCheckboxes = targetStep.querySelectorAll('.custom-product-steps__nested-checkbox-input');
            allNestedCheckboxes.forEach((cb) => (cb.checked = false));

            // Then check the saved ones and restore quantities
            stepData[stepNumber].nestedCheckboxes.forEach((nestedInfo) => {
              const nestedCheckbox = document.getElementById(nestedInfo.id);
              if (nestedCheckbox) {
                nestedCheckbox.checked = true;

                // Restore quantity
                const quantityInput = targetStep.querySelector(
                  `.custom-product-steps__quantity-input[data-nested-id="${nestedInfo.id}"]`
                );
                if (quantityInput && nestedInfo.quantity) {
                  quantityInput.value = nestedInfo.quantity;
                }

                // Update visual state
                if (window.updateNestedCheckboxState) {
                  window.updateNestedCheckboxState(nestedCheckbox);
                }

                // Show gallery if checkbox has one
                if (window.handleCheckboxGalleryChange) {
                  window.handleCheckboxGalleryChange(nestedCheckbox);
                }
              }
            });
          }
        } else {
        // No saved data, use currently checked radio
        const checkedRadio = targetStep.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          if (window.updateStepImage) {
            window.updateStepImage(checkedRadio);
          }
          if (window.handleNestedCheckboxBehavior) {
            window.handleNestedCheckboxBehavior(checkedRadio);
          }
        }
      }

        // Update price for this step
        updatePrice(stepNumber);

        // Validate continue button state
        if (window.validateContinueButton) {
          window.validateContinueButton(stepNumber);
        }
      }

      if (targetImage) {
        targetImage.classList.add('active-step');

        // Duplicate image for mobile
        if (window.innerWidth <= 768 && targetStep) {
          const mobileImagePosition = targetStep.getAttribute('data-mobile-image-position') || 'after_product_info';

          // Remove any existing mobile duplicates in this step
          const existingDuplicates = targetStep.querySelectorAll('.custom-product-steps__image-mobile-duplicate');
          existingDuplicates.forEach(dup => dup.remove());

          // Skip creating image if set to hide
          if (mobileImagePosition === 'hide') {
            return;
          }

          // Check if there's an active gallery first
          const activeGallery = targetImage.querySelector('.custom-product-steps__gallery[style*="display: flex"], .custom-product-steps__gallery[style*="display:flex"]');

          if (activeGallery) {
            // Create a wrapper div
            const imageDuplicate = document.createElement('div');
            imageDuplicate.classList.add('custom-product-steps__image-mobile-duplicate');

            // Clone the gallery
            const galleryClone = activeGallery.cloneNode(true);
            galleryClone.style.position = 'relative';
            galleryClone.style.display = 'flex';
            imageDuplicate.appendChild(galleryClone);

            // Insert based on setting
            if (mobileImagePosition === 'inside_selected_option') {
              // Insert inside the selected radio option
              const selectedRadio = targetStep.querySelector('input[type="radio"]:checked');
              if (selectedRadio) {
                const selectedOption = selectedRadio.closest('.custom-product-steps__option');
                if (selectedOption) {
                  selectedOption.appendChild(imageDuplicate);
                }
              }
            } else {
              // Default: Insert after product-info
              const productInfo = targetStep.querySelector('.custom-product-steps__product-info');
              if (productInfo) {
                productInfo.after(imageDuplicate);
              }
            }
          } else {
            // Get only the active image
            const activeImage = targetImage.querySelector('.option-image.active');
            if (activeImage) {
              // Create a wrapper div
              const imageDuplicate = document.createElement('div');
              imageDuplicate.classList.add('custom-product-steps__image-mobile-duplicate');

              // Clone only the active image
              const activeImageClone = activeImage.cloneNode(true);
              imageDuplicate.appendChild(activeImageClone);

              // Insert based on setting
              if (mobileImagePosition === 'inside_selected_option') {
                // Insert inside the selected radio option
                const selectedRadio = targetStep.querySelector('input[type="radio"]:checked');
                if (selectedRadio) {
                  const selectedOption = selectedRadio.closest('.custom-product-steps__option');
                  if (selectedOption) {
                    selectedOption.appendChild(imageDuplicate);
                  }
                }
              } else {
                // Default: Insert after product-info
                const productInfo = targetStep.querySelector('.custom-product-steps__product-info');
                if (productInfo) {
                  productInfo.after(imageDuplicate);
                }
              }
            }
          }
        }
      }

      // Scroll to top of page (multiple attempts to ensure it works)
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 150);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 300);
    }

    function updateUrl(stepNumber) {
      // Update URL without reloading page
      const newUrl = window.location.pathname + window.location.search + '#step-' + stepNumber;
      window.history.pushState({ step: stepNumber }, '', newUrl);
    }

    // Function to add product to cart
    function addToCart(variantId, quantity = 1) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          return data;
        })
        .catch((error) => {
          throw error;
        });
    }

    // Function to handle continue button click
    window.handleContinueClick = function (stepNumber) {
      const stepElement = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);
      if (!stepElement) return;

      const continueButton = stepElement.querySelector('.custom-product-steps__continue-button');
      if (!continueButton) return;

      // If button is disabled, scroll to selected radio and show tooltip
      if (continueButton.disabled) {
        const selectedRadio = stepElement.querySelector('input[type="radio"]:checked');
        if (!selectedRadio) return;

        const selectedOption = selectedRadio.closest('.custom-product-steps__option');
        if (!selectedOption) return;

        // Scroll to the selected option
        selectedOption.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Show tooltip on the option
        let tooltip = selectedOption.querySelector('.custom-product-steps__option-tooltip');
        if (!tooltip) {
          tooltip = document.createElement('div');
          tooltip.className = 'custom-product-steps__option-tooltip';
          tooltip.textContent = 'Please select at least one product to continue';
          selectedOption.style.position = 'relative';
          selectedOption.appendChild(tooltip);
        }

        tooltip.classList.add('show');

        // Hide tooltip after 3 seconds
        setTimeout(() => {
          tooltip.classList.remove('show');
        }, 3000);

        return;
      }

      // Button is enabled, proceed with navigation
      navigateStep(stepNumber, 1);
    };

    window.navigateStep = function (currentStep, direction) {
      // Save current step's selection with product data
      const selectedOption = document.querySelector(
        `.custom-product-steps__step-content[data-step="${currentStep}"] input[type="radio"]:checked`
      );
      const currentStepElement = document.querySelector(
        `.custom-product-steps__step-content[data-step="${currentStep}"]`
      );
      const continueButton = currentStepElement?.querySelector(
        '.custom-product-steps__button:not(.custom-product-steps__button--back)'
      );
      const stepVariantId = continueButton?.getAttribute('data-variant-id');

      // Save checkbox states
      const checkedCheckboxes = currentStepElement?.querySelectorAll('.custom-product-steps__checkbox-input:checked');
      const checkboxData = [];
      if (checkedCheckboxes) {
        checkedCheckboxes.forEach((checkbox) => {
          checkboxData.push({
            id: checkbox.id,
            value: checkbox.value,
            priceModifier: checkbox.getAttribute('data-price-modifier'),
            variantId: checkbox.getAttribute('data-variant-id'),
          });
        });
      }

      // Save nested checkbox states
      const checkedNestedCheckboxes = currentStepElement?.querySelectorAll(
        '.custom-product-steps__nested-checkbox-input:checked'
      );
      const nestedCheckboxData = [];
      if (checkedNestedCheckboxes) {
        checkedNestedCheckboxes.forEach((checkbox) => {
          // Skip checkboxes that are disabled because their parent option is not selected
          if (checkbox.getAttribute('data-parent-disabled') === 'true') {
            return; // Skip this checkbox
          }

          const nestedId = checkbox.id;
          const quantityInput = currentStepElement?.querySelector(
            `.custom-product-steps__quantity-input[data-nested-id="${nestedId}"]`
          );
          const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

          nestedCheckboxData.push({
            id: checkbox.id,
            value: checkbox.value,
            priceModifier: checkbox.getAttribute('data-price-modifier'),
            variantId: checkbox.getAttribute('data-variant-id'),
            quantity: quantity,
          });
        });
      }

      // Get step title for summary
      const stepTitle = currentStepElement?.querySelector('.custom-product-steps__product-title span')?.textContent || '';
      const stepBasePrice = currentStepElement?.querySelector('.custom-product-steps__price')?.getAttribute('data-base-price') || '';

      if (selectedOption) {
        stepData[currentStep] = {
          value: selectedOption.value,
          id: selectedOption.id,
          priceModifier: selectedOption.getAttribute('data-price-modifier'),
          optionVariantId: selectedOption.getAttribute('data-variant-id'),
          stepVariantId: stepVariantId,
          checkboxes: checkboxData,
          nestedCheckboxes: nestedCheckboxData,
          stepTitle: stepTitle,
          stepBasePrice: stepBasePrice,
        };
      }

      // Calculate next step number
      const allSteps = document.querySelectorAll('.custom-product-steps__step-content');
      const stepNumbers = Array.from(allSteps)
        .map((step) => parseInt(step.getAttribute('data-step')))
        .sort((a, b) => a - b);

      const currentIndex = stepNumbers.indexOf(currentStep);
      const nextIndex = currentIndex + direction;

      // Check if this is the last step
      const isLastStep = nextIndex >= stepNumbers.length;

      // Add loading spinner to continue button on last step
      if (isLastStep && direction === 1) {
        const continueBtn = currentStepElement?.querySelector('.custom-product-steps__continue-button');
        if (continueBtn) {
          continueBtn.classList.add('loading');
          continueBtn.disabled = true;
        }
      }

      // If moving forward (direction = 1)
      if (direction === 1) {
        if (batchMode) {
          // BATCH MODE: Just save and navigate, add all products on final step
          if (isLastStep) {
            // This is the final step - add all collected products
            addAllProductsToCart()
              .then(() => {
                proceedToNextStep(nextIndex, stepNumbers);
              })
              .catch((error) => {
                const continueBtn = currentStepElement?.querySelector('.custom-product-steps__continue-button');
                if (continueBtn) {
                  continueBtn.classList.remove('loading');
                  continueBtn.disabled = false;
                }
                alert('Error adding products to cart. Please try again.');
              });
          } else {
            // Not the final step yet, just navigate
            proceedToNextStep(nextIndex, stepNumbers);
          }
        } else {
          // IMMEDIATE MODE: Add products at each step (original behavior)
          // Get the selected option's product
          const optionVariantId = selectedOption?.getAttribute('data-variant-id');

          // Collect products to add for this step
          const productsToAdd = [];
          if (stepVariantId) {
            productsToAdd.push({ id: stepVariantId, type: 'step main product' });
          }
          if (optionVariantId) {
            productsToAdd.push({ id: optionVariantId, type: 'selected option product' });
          }

          // Add checkbox products
          checkboxData.forEach((checkboxInfo) => {
            if (checkboxInfo.variantId) {
              productsToAdd.push({ id: checkboxInfo.variantId, type: `checkbox: ${checkboxInfo.value}` });
            }
          });

          // Add nested checkbox products
          nestedCheckboxData.forEach((nestedInfo) => {
            if (nestedInfo.variantId) {
              productsToAdd.push({
                id: nestedInfo.variantId,
                type: `nested checkbox: ${nestedInfo.value}`,
                quantity: nestedInfo.quantity || 1,
              });
            }
          });

          if (productsToAdd.length > 0) {
            // Add products to cart immediately
            addProductsSequentially(productsToAdd)
              .then(() => {
                proceedToNextStep(nextIndex, stepNumbers);
              })
              .catch((error) => {
                const continueBtn = currentStepElement?.querySelector('.custom-product-steps__continue-button');
                if (continueBtn) {
                  continueBtn.classList.remove('loading');
                  continueBtn.disabled = false;
                }
                alert('Error adding products to cart. Please try again.');
              });
          } else {
            // No products to add, just navigate
            proceedToNextStep(nextIndex, stepNumbers);
          }
        }
      } else {
        // Moving backward, just navigate
        proceedToNextStep(nextIndex, stepNumbers);
      }
    };

    // Function to add multiple products sequentially
    function addProductsSequentially(products) {
      return products.reduce((promise, product) => {
        return promise.then(() => {
          const quantity = product.quantity || 1;
          return addToCart(product.id, quantity);
        });
      }, Promise.resolve());
    }

    // Function to add all collected products from all steps
    function addAllProductsToCart() {
      const allProducts = [];

      // Iterate through all saved step data
      Object.keys(stepData).forEach((stepNum) => {
        const data = stepData[stepNum];

        // Add step's main product
        if (data.stepVariantId) {
          allProducts.push({
            id: data.stepVariantId,
            type: `Step ${stepNum} - main product`,
          });
        }

        // Add selected option's product
        if (data.optionVariantId) {
          allProducts.push({
            id: data.optionVariantId,
            type: `Step ${stepNum} - ${data.value}`,
          });
        }

        // Add checkbox products
        if (data.checkboxes && data.checkboxes.length > 0) {
          data.checkboxes.forEach((checkboxInfo) => {
            if (checkboxInfo.variantId) {
              allProducts.push({
                id: checkboxInfo.variantId,
                type: `Step ${stepNum} - checkbox: ${checkboxInfo.value}`,
              });
            }
          });
        }

        // Add nested checkbox products
        if (data.nestedCheckboxes && data.nestedCheckboxes.length > 0) {
          data.nestedCheckboxes.forEach((nestedInfo) => {
            if (nestedInfo.variantId) {
              allProducts.push({
                id: nestedInfo.variantId,
                type: `Step ${stepNum} - nested checkbox: ${nestedInfo.value}`,
                quantity: nestedInfo.quantity || 1,
              });
            }
          });
        }
      });

      // Add gift products
      const giftProducts = document.querySelectorAll('.custom-product-steps__gift-product');
      if (giftProducts && giftProducts.length > 0) {
        giftProducts.forEach(function(giftProduct) {
          const variantId = giftProduct.getAttribute('data-variant-id');
          const productId = giftProduct.getAttribute('data-product-id');
          if (variantId) {
            allProducts.push({
              id: variantId,
              type: 'Gift Product',
              quantity: 1
            });
          }
        });
      }

      if (allProducts.length > 0) {
        return addProductsSequentially(allProducts);
      } else {
        return Promise.resolve();
      }
    }

    function proceedToNextStep(nextIndex, stepNumbers) {
      if (nextIndex >= 0 && nextIndex < stepNumbers.length) {
        const nextStepNumber = stepNumbers[nextIndex];
        showStep(nextStepNumber);

        // Force scroll to top with multiple attempts to ensure it works
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 150);
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 300);
      } else if (nextIndex >= stepNumbers.length) {
        // Last step completed - redirect based on section setting
        const section = document.querySelector('.custom-product-steps');
        const redirectDestination = section ? section.getAttribute('data-redirect-destination') : 'cart';
        const redirectUrl = redirectDestination === 'checkout' ? '/checkout' : '/cart';
        window._skipBeforeUnload = true;
        window.location.href = redirectUrl;
      }
    }

    // Handle browser back/forward buttons
    window.addEventListener('popstate', function (event) {
      const urlHash = window.location.hash;
      if (urlHash && urlHash.startsWith('#step-')) {
        const stepFromUrl = parseInt(urlHash.replace('#step-', ''));
        if (!isNaN(stepFromUrl)) {
          const allSteps = document.querySelectorAll('.custom-product-steps__step-content');
          const stepNumbers = Array.from(allSteps).map((step) => parseInt(step.getAttribute('data-step')));

          if (stepNumbers.includes(stepFromUrl)) {
            // Use showStep to properly restore state
            const allStepElements = document.querySelectorAll('.custom-product-steps__step-content');
            const allImages = document.querySelectorAll('.custom-product-steps__image[data-step-image]');

            allStepElements.forEach((step) => step.classList.remove('active-step'));
            allImages.forEach((img) => img.classList.remove('active-step'));

            const targetStep = document.querySelector(
              `.custom-product-steps__step-content[data-step="${stepFromUrl}"]`
            );
            const targetImage = document.querySelector(
              `.custom-product-steps__image[data-step-image="${stepFromUrl}"]`
            );

            if (targetStep) {
              targetStep.classList.add('active-step');

              // Restore previously selected option if exists
              if (stepData[stepFromUrl] && stepData[stepFromUrl].id) {
                const savedRadio = document.getElementById(stepData[stepFromUrl].id);
                if (savedRadio) {
                  savedRadio.checked = true;

                  // Update visual state
                  const allOptions = targetStep.querySelectorAll('.custom-product-steps__option');
                  allOptions.forEach((option) => {
                    const radio = option.querySelector('input[type="radio"]');
                    if (radio && radio.checked) {
                      option.classList.add('selected');
                    } else {
                      option.classList.remove('selected');
                    }
                  });

                  // Update image
                  if (window.updateStepImage) {
                    window.updateStepImage(savedRadio);
                  }

                  // Apply nested checkbox behavior
                  if (window.handleNestedCheckboxBehavior) {
                    window.handleNestedCheckboxBehavior(savedRadio);
                  }
                }

                // Restore checkbox states
                if (stepData[stepFromUrl].checkboxes) {
                  const allCheckboxes = targetStep.querySelectorAll('.custom-product-steps__checkbox-input');
                  allCheckboxes.forEach((cb) => (cb.checked = false));

                  stepData[stepFromUrl].checkboxes.forEach((checkboxInfo) => {
                    const checkbox = document.getElementById(checkboxInfo.id);
                    if (checkbox) {
                      checkbox.checked = true;

                      // Show gallery if checkbox has one
                      if (window.handleCheckboxGalleryChange) {
                        window.handleCheckboxGalleryChange(checkbox);
                      }
                    }
                  });
                }

                // Restore nested checkbox states
                if (stepData[stepFromUrl].nestedCheckboxes) {
                  const allNestedCheckboxes = targetStep.querySelectorAll(
                    '.custom-product-steps__nested-checkbox-input'
                  );
                  allNestedCheckboxes.forEach((cb) => (cb.checked = false));

                  stepData[stepFromUrl].nestedCheckboxes.forEach((nestedInfo) => {
                    const nestedCheckbox = document.getElementById(nestedInfo.id);
                    if (nestedCheckbox) {
                      nestedCheckbox.checked = true;

                      // Restore quantity
                      const quantityInput = targetStep.querySelector(
                        `.custom-product-steps__quantity-input[data-nested-id="${nestedInfo.id}"]`
                      );
                      if (quantityInput && nestedInfo.quantity) {
                        quantityInput.value = nestedInfo.quantity;
                      }

                      // Update visual state
                      if (window.updateNestedCheckboxState) {
                        window.updateNestedCheckboxState(nestedCheckbox);
                      }

                      // Show gallery if checkbox has one
                      if (window.handleCheckboxGalleryChange) {
                        window.handleCheckboxGalleryChange(nestedCheckbox);
                      }
                    }
                  });
                }
              } else {
                const checkedRadio = targetStep.querySelector('input[type="radio"]:checked');
                if (checkedRadio && window.updateStepImage) {
                  window.updateStepImage(checkedRadio);
                }
              }
            }

            if (targetImage) targetImage.classList.add('active-step');
          }
        }
      }
    });

    // Make updatePrice globally accessible for summary step
    window.updatePrice = updatePrice;

    // Summary step functions
    window.populateSummary = function() {
      const summaryOptions = document.getElementById('summary-selected-options');
      const summaryTotal = document.getElementById('summary-total-price');

      let totalPrice = 0;

      // Only populate selections section if it exists (when "Show Your Selections" is enabled)
      if (summaryOptions) {
        // Clear existing options (except title)
        const titleElement = summaryOptions.querySelector('.custom-product-steps__summary-options-title');
        summaryOptions.innerHTML = '';
        if (titleElement) {
          summaryOptions.appendChild(titleElement);
        } else {
          const newTitle = document.createElement('div');
          newTitle.className = 'custom-product-steps__summary-options-title';
          newTitle.textContent = 'Your Selections:';
          summaryOptions.appendChild(newTitle);
        }
      }

      // Calculate total price and populate selections (iterate through all saved step data)
      Object.keys(stepData).sort((a, b) => parseInt(a) - parseInt(b)).forEach(function(stepNum) {
        const data = stepData[stepNum];

        // Add main step product title first
        if (data.stepTitle && summaryOptions) {
          const stepTitleDiv = document.createElement('div');
          stepTitleDiv.className = 'custom-product-steps__summary-option';

          const labelSpan = document.createElement('span');
          labelSpan.className = 'custom-product-steps__summary-option-label';
          labelSpan.innerHTML = '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>' + data.stepTitle;

          const valueSpan = document.createElement('span');
          valueSpan.className = 'custom-product-steps__summary-option-value';
          valueSpan.textContent = data.stepBasePrice || 'Included';

          stepTitleDiv.appendChild(labelSpan);
          stepTitleDiv.appendChild(valueSpan);
          summaryOptions.appendChild(stepTitleDiv);
        }

        // Add main selection (radio option)
        if (data.value) {
          const priceModifier = parseFloat(data.priceModifier) || 0;
          totalPrice += priceModifier;

          // Only create DOM elements if selections section is visible
          if (summaryOptions) {
            const optionDiv = document.createElement('div');
            optionDiv.className = 'custom-product-steps__summary-option';

            const labelSpan = document.createElement('span');
            labelSpan.className = 'custom-product-steps__summary-option-label';
            labelSpan.innerHTML = '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>' + data.value;

            const valueSpan = document.createElement('span');
            valueSpan.className = 'custom-product-steps__summary-option-value';
            if (priceModifier > 0) {
              valueSpan.textContent = '+$' + priceModifier.toFixed(0);
            } else if (priceModifier < 0) {
              valueSpan.textContent = '-$' + Math.abs(priceModifier).toFixed(0);
            } else {
              valueSpan.textContent = 'Included';
            }

            optionDiv.appendChild(labelSpan);
            optionDiv.appendChild(valueSpan);
            summaryOptions.appendChild(optionDiv);
          }
        }

        // Add checkbox selections
        if (data.checkboxes && data.checkboxes.length > 0) {
          data.checkboxes.forEach(function(checkbox) {
            const priceModifier = parseFloat(checkbox.priceModifier) || 0;
            totalPrice += priceModifier;

            // Only create DOM elements if selections section is visible
            if (summaryOptions) {
              const optionDiv = document.createElement('div');
              optionDiv.className = 'custom-product-steps__summary-option';

              const labelSpan = document.createElement('span');
              labelSpan.className = 'custom-product-steps__summary-option-label';
              labelSpan.innerHTML = '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>' + checkbox.value;

              const valueSpan = document.createElement('span');
              valueSpan.className = 'custom-product-steps__summary-option-value';
              if (priceModifier > 0) {
                valueSpan.textContent = '+$' + priceModifier.toFixed(0);
              } else if (priceModifier < 0) {
                valueSpan.textContent = '-$' + Math.abs(priceModifier).toFixed(0);
              } else {
                valueSpan.textContent = 'Included';
              }

              optionDiv.appendChild(labelSpan);
              optionDiv.appendChild(valueSpan);
              summaryOptions.appendChild(optionDiv);
            }
          });
        }

        // Add nested checkbox selections
        if (data.nestedCheckboxes && data.nestedCheckboxes.length > 0) {
          data.nestedCheckboxes.forEach(function(nested) {
            const priceModifier = (parseFloat(nested.priceModifier) || 0) * (nested.quantity || 1);
            totalPrice += priceModifier;

            // Only create DOM elements if selections section is visible
            if (summaryOptions) {
              const optionDiv = document.createElement('div');
              optionDiv.className = 'custom-product-steps__summary-option';

              const labelSpan = document.createElement('span');
              labelSpan.className = 'custom-product-steps__summary-option-label';
              const qtyText = nested.quantity > 1 ? ' (x' + nested.quantity + ')' : '';
              labelSpan.innerHTML = '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>' + nested.value + qtyText;

              const valueSpan = document.createElement('span');
              valueSpan.className = 'custom-product-steps__summary-option-value';
              if (priceModifier > 0) {
                valueSpan.textContent = '+$' + priceModifier.toFixed(0);
              } else if (priceModifier < 0) {
                valueSpan.textContent = '-$' + Math.abs(priceModifier).toFixed(0);
              } else {
                valueSpan.textContent = 'Included';
              }

              optionDiv.appendChild(labelSpan);
              optionDiv.appendChild(valueSpan);
              summaryOptions.appendChild(optionDiv);
            }
          });
        }
      });

      // Get base prices from all steps
      document.querySelectorAll('.custom-product-steps__price[data-base-price]').forEach(function(priceEl) {
        const basePrice = priceEl.getAttribute('data-base-price');
        if (basePrice) {
          const parsed = parseFloat(basePrice.replace(/[^0-9.\-]/g, '')) || 0;
          totalPrice += parsed;
        }
      });

      // Update total price (always update, regardless of whether selections section is shown)
      if (summaryTotal) {
        summaryTotal.textContent = '$' + totalPrice.toFixed(0);
      }
    };

    window.handleSummaryCheckout = function() {
      // Get the button and add loading state
      const checkoutButton = document.querySelector('.custom-product-steps__summary-checkout-btn');
      if (checkoutButton) {
        checkoutButton.classList.add('loading');
        checkoutButton.disabled = true;
      }

      // Get redirect destination from section settings
      const section = document.querySelector('.custom-product-steps');
      const redirectDestination = section ? section.getAttribute('data-redirect-destination') : 'cart';
      const redirectUrl = redirectDestination === 'checkout' ? '/checkout' : '/cart';

      // Add all products to cart
      addAllProductsToCart()
        .then(function() {
          // Redirect to cart or checkout based on setting
          window.location.href = redirectUrl;
        })
        .catch(function(error) {
          console.error('Error adding products to cart:', error);
          alert('Error adding products to cart. Please try again.');

          // Remove loading state on error
          if (checkoutButton) {
            checkoutButton.classList.remove('loading');
            checkoutButton.disabled = false;
          }
        });
    };

    // Update showStep to populate summary when navigating to summary step
    const originalShowStep = showStep;
    showStep = function(stepNumber) {
      originalShowStep(stepNumber);

      // Check if this is a summary step
      const targetStep = document.querySelector(`.custom-product-steps__step-content[data-step="${stepNumber}"]`);
      if (targetStep && targetStep.getAttribute('data-block-type') === 'summary') {
        window.populateSummary();
      }
    };
  })();

// ========================================
// HELPER FUNCTIONS
// ========================================

// Cookie helper function (minimal, only for savings price)
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

// Function to format price with comma separator
function formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// Update savings display from cookie
function updateSavingsFromCookie() {
    const savingsPrice = getCookie('ev_savings_price');

    if (savingsPrice && savingsPrice !== '0') {
        const savingsAmountElement = document.querySelector('.custom-product-steps__summary-highlight-amount');

        if (savingsAmountElement) {
            const formattedPrice = formatPrice(savingsPrice);
            savingsAmountElement.textContent = `$${formattedPrice}+`;
            console.log('✅ Savings updated from cookie: $' + formattedPrice);
        }
    } else {
        console.log('ℹ️ No savings price found in cookie (or price is 0)');
    }
}

// Run when page loads
document.addEventListener('DOMContentLoaded', function() {
    updateSavingsFromCookie();

    // Also update every 2 seconds if user navigates back and forth
    setInterval(updateSavingsFromCookie, 2000);
});

// Run immediately if DOM already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    updateSavingsFromCookie();
}

// ========================================
// REFRESH BEHAVIOR SYSTEM (Option 1 & 2)
// ========================================

// Warning mode is always enabled (no option to change)

// Close warning modal without clearing selections (Cancel button)
function cancelRefresh() {
    console.log('🚫 User cancelled refresh - keeping selections');
    document.getElementById('refreshWarningModal').classList.remove('active');
    // Keep current step and selections as they are
}

// Confirm refresh and clear all selections (Yes button)
function confirmRefresh() {
    console.log('✅ User confirmed refresh - clearing selections');
    document.getElementById('refreshWarningModal').classList.remove('active');
    localStorage.removeItem('user_has_selections');
    localStorage.removeItem('user_current_step');

    // Reset to step 1
    const firstStep = document.querySelector('.custom-product-steps__step-content');
    if (firstStep) {
        document.querySelectorAll('.custom-product-steps__step-content').forEach(step => {
            step.classList.remove('active-step');
        });
        firstStep.classList.add('active-step');

        // Also reset images if they exist
        document.querySelectorAll('.custom-product-steps__image').forEach(img => {
            img.classList.remove('active-step');
        });
        const firstImage = document.querySelector('.custom-product-steps__image');
        if (firstImage) {
            firstImage.classList.add('active-step');
        }
    }

    console.log('🔄 Reset to step 1 complete');
}


// Get current step number
function getCurrentStep() {
    const activeStep = document.querySelector('.custom-product-steps__step-content.active-step');
    if (activeStep) {
        return activeStep.getAttribute('data-step') || '1';
    }
    return '1';
}

// Detect if page was refreshed
function wasPageRefreshed() {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation) {
        return navigation.type === 'reload';
    }
    // Fallback for older browsers
    return performance.navigation && performance.navigation.type === 1;
}

// Mark that user has made selections
function markUserHasSelections() {
    const currentStep = getCurrentStep();
    localStorage.setItem('user_has_selections', 'true');
    localStorage.setItem('user_current_step', currentStep);
    console.log('✍️ User selections marked in localStorage (Step:', currentStep, ')');
}

// Check if user has made selections
function userHasSelections() {
    return localStorage.getItem('user_has_selections') === 'true';
}

// Initialize refresh behavior system (WARNING MODE ONLY)
function initRefreshBehavior() {
    console.log('⚠️ Setting up beforeunload warning for step 2+');

    window.addEventListener('beforeunload', function(e) {
        const currentStep = getCurrentStep();
        const stepNumber = parseInt(currentStep) || 1;

        // Check if current step is the summary/checkout step
        const activeStepElement = document.querySelector('.custom-product-steps__step-content.active-step');
        const isSummaryStep = activeStepElement?.getAttribute('data-block-type') === 'summary';

        console.log('🔍 Refresh attempt detected! Current step:', stepNumber, 'Is summary:', isSummaryStep);

        // Only show warning on step 2+ BUT NOT on summary/checkout step or intentional redirect
        if (stepNumber >= 2 && !isSummaryStep && !window._skipBeforeUnload) {
            console.log('⚠️ WARNING: Showing refresh confirmation on step', stepNumber);

            // Standard way to show browser's confirmation dialog
            e.preventDefault();
            e.returnValue = ''; // Chrome requires returnValue to be set

            // Clear selections when they actually leave/refresh
            localStorage.removeItem('user_has_selections');
            localStorage.removeItem('user_current_step');

            return ''; // Some browsers show this message
        } else {
            console.log('✅ Step', stepNumber, '- allowing refresh without warning (step 1 or summary)');
            // Clear selections anyway
            localStorage.removeItem('user_has_selections');
            localStorage.removeItem('user_current_step');
        }
    });

    // After page loads, check if it was refreshed and reset to step 1
    if (wasPageRefreshed()) {
        console.log('🔄 Page was refreshed - resetting to step 1');

        // Update URL to step 1 or remove hash
        if (window.location.hash && window.location.hash !== '#step-1') {
            window.history.replaceState(null, null, '#step-1');
            console.log('🔗 URL updated to #step-1');
        }

        setTimeout(() => {
            const firstStep = document.querySelector('.custom-product-steps__step-content');
            if (firstStep) {
                document.querySelectorAll('.custom-product-steps__step-content').forEach(step => {
                    step.classList.remove('active-step');
                });
                firstStep.classList.add('active-step');

                // Also reset images
                document.querySelectorAll('.custom-product-steps__image').forEach(img => {
                    img.classList.remove('active-step');
                });
                const firstImage = document.querySelector('.custom-product-steps__image');
                if (firstImage) {
                    firstImage.classList.add('active-step');
                }
                console.log('✅ Reset to step 1 complete');
            }
        }, 100);
    }
}

// Setup all event listeners after DOM is loaded
function setupEventListeners() {
    console.log('🎯 Setting up event listeners for refresh behavior');

    // Track user interactions
    document.addEventListener('change', function(e) {
        if (e.target.type === 'radio' || e.target.type === 'checkbox') {
            console.log('📝 Change detected on:', e.target.type, e.target.name || e.target.id);
            markUserHasSelections();
        }
    });

    // Track quantity changes
    document.addEventListener('input', function(e) {
        if (e.target.classList.contains('custom-product-steps__quantity-input')) {
            console.log('📝 Quantity change detected');
            markUserHasSelections();
        }
    });

    // Also mark selections when "Next" button is clicked
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('custom-product-steps__button--next') ||
            e.target.closest('.custom-product-steps__button--next')) {
            console.log('📝 Next button clicked');
            markUserHasSelections();
        }
    });

    // Clear localStorage when going back to step 1
    const backButtons = document.querySelectorAll('.custom-product-steps__button--back');
    console.log('🔍 Found', backButtons.length, 'back buttons');
    backButtons.forEach(button => {
        button.addEventListener('click', function() {
            const currentStep = getCurrentStep();
            if (currentStep === '1' || currentStep === 1) {
                localStorage.removeItem('user_has_selections');
                localStorage.removeItem('user_current_step');
                console.log('🔄 Back to step 1 - selections cleared');
            }
        });
    });

    console.log('✅ Event listeners setup complete');
}

// Initialize everything after DOM is loaded
function initializeRefreshSystem() {
    console.log('🚀 Initializing refresh system...');
    setupEventListeners();
    initRefreshBehavior();
}

// Initialize on page load - ensure DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRefreshSystem);
} else {
    // DOM already loaded
    initializeRefreshSystem();
}

